/**
 * Minimal className joiner. Drops falsy values.
 * Keeps the helper dep-free (no clsx, no tailwind-merge) — call sites must
 * pass non-conflicting utility sets.
 */
export function cn(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(' ');
}
